import { render } from "./EbmDataEditorModal.vue?vue&type=template&id=5f623cd4&scoped=true"
import script from "./EbmDataEditorModal.vue?vue&type=script&lang=js"
export * from "./EbmDataEditorModal.vue?vue&type=script&lang=js"

import "./EbmDataEditorModal.vue?vue&type=style&index=0&id=5f623cd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f623cd4"]])

export default __exports__